import { AiService } from 'src/app/models/api/agentStep.model';
import { CitationResourceType } from './ai-agent-citation.component';

type CitationSource = {
  type?: string;
  m365ResourceType?: string;
  vertexAiSourceType?: string;
};

export function resolveCitationResourceType(source: unknown, service: AiService): CitationResourceType {
  const s = source as CitationSource;
  const t = (s?.type as string | undefined)?.toLowerCase();

  switch (t) {
    case 'website':
      return CitationResourceType.WEBSITE;
    case 'file':
      return CitationResourceType.FILE;
    case 'messages':
      return CitationResourceType.MESSAGES;
    case 'unknown':
      return CitationResourceType.UNKNOWN;
  }

  if (service === AiService.m365Copilot) {
    return s?.m365ResourceType === 'website' ? CitationResourceType.WEBSITE : CitationResourceType.FILE;
  }

  if (service === AiService.vertexAi) {
    return s?.vertexAiSourceType === 'web' ? CitationResourceType.WEBSITE : CitationResourceType.FILE;
  }

  return CitationResourceType.FILE;
}
